export const ActionTypes = {
  SET_THEME: "SET_THEME",
  SET_DARK: "SET_DARK",
  DATA: "DATA",
  FILTERED_DATA: "FILTERED_DATA",
  TOP_STORIES: "TOP_STORIES",
  TRENDING: "TRENDING",
  POPULAR: "POPULAR",
  TOP_HEADLINES: "TOP_HEADLINES",
};
